import { useControllableValue } from 'ahooks';
import cx from 'classnames';
import type { Key, ReactNode } from 'react';
import { Icon } from '..';
import './index.less';

const prefix = 'beukay';
const getCx = (className: string) => `${prefix}-${className}`;

type IOption<T> = {
  key: T;
  name: number | string;
  extra?: ReactNode;
};

export type IProps<T> = {
  options?: IOption<T>[];
  defaultValue?: T;
  value?: T;
  onChange?: (value: T) => void;
};

function SelectTags<T = any>({
  options,
  defaultValue,
  value,
  onChange,
}: IProps<T>) {
  const [val, setVal] = useControllableValue<T>({
    defaultValue,
    value,
    onChange,
  });

  return (
    <div className={getCx('select-tags')}>
      {options?.map((item) => (
        <div key={item.key as Key} className={getCx('select-tag-wrapper')}>
          <div
            className={cx(
              getCx('select-tag'),
              item.key === val && getCx('select-tag-active'),
            )}
            onClick={() => setVal(item.key)}
          >
            <span>{item.name}</span>
            {item.key === val && (
              <Icon
                type="icon-a-icon_success3x"
                className={getCx('select-tag-icon')}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SelectTags;
